import React from "react";
import {Select} from "antd";
import {PlannerTaskSystemStatus} from "../../../../../../../../models/planner/planner";
import {WidgetProps} from "../../../../../../../common/cards-view/model/model";

export const TaskStatusWidget: React.FC<WidgetProps> = ({onChange, value, placeholder}) => {

    return (
        <Select
            mode={"multiple"}
            onChange={onChange as any}
            value={value as any}
            allowClear={true}
            showSearch
            optionFilterProp={"children"}
            placeholder={placeholder}
            maxTagCount={1}
            variant={"filled"}
        >
            {Object.values(PlannerTaskSystemStatus).map(v =>
                <Select.Option key={v} value={v}>{v.capitalizeFirstLetter()}</Select.Option>)}
        </Select>
    )
}